export default {
  AUTOMATION: "App\\Automation\\Models\\Automation",
  GLOBAL_AUTOMATION: "App\\Automation\\Models\\GlobalAutomation",
  GLOBAL_AUTOMATION_CONFIGURATION: "App\\Automation\\Models\\GlobalAutomationConfiguration",
};
